function i(e) {
  const t = {}, r = [];
  return e.reduce((a, n) => t[n.id] ? a : (t[n.id] = !0, [...a, n]), r);
}
function g(e) {
  return e.sort((t, r) => new Date(r.inserted_at).getTime() - new Date(t.inserted_at).getTime());
}
function s(e) {
  const { inserted_at_date_range: t, ...r } = e;
  if (!t)
    return r;
  const a = {}, n = t.inclusive ?? !1;
  if (t.start) {
    const d = n ? "inserted_at.gte" : "inserted_at.gt";
    a[d] = t.start;
  }
  if (t.end) {
    const d = n ? "inserted_at.lte" : "inserted_at.lt";
    a[d] = t.end;
  }
  return { ...r, ...a };
}
function u(e) {
  if (typeof (e == null ? void 0 : e.trigger_data) == "object")
    return JSON.stringify(e.trigger_data);
  if (typeof (e == null ? void 0 : e.trigger_data) == "string")
    return e.trigger_data;
}
export {
  i as deduplicateItems,
  u as getFormattedTriggerData,
  s as mergeDateRangeParams,
  g as sortItems
};
//# sourceMappingURL=utils.mjs.map
